var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { BASE_BORDER_WIDTH, BASE_FONT_BOLD_WEIGHT, BASE_FONT_FAMILY, FONT_LINE_HEIGHT_M, FONT_SIZE_M, SPACING_L, SPACING_S } from "../../helpers";
import getFlexStyleForColumn from '../utils/getFlexStyleForColumn';
var BodyCell = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    color: ", ";\n\n    padding: ", " ", " ", " ", ";\n    height: 100%;\n    box-sizing: border-box;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    color: ", ";\n\n    ", "\n"], ["\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    color: ", ";\n\n    padding: ", " ", " ", " ", ";\n    height: 100%;\n    box-sizing: border-box;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    color: ", ";\n\n    ",
    "\n"])), FONT_SIZE_M, BASE_FONT_BOLD_WEIGHT, BASE_FONT_FAMILY, FONT_LINE_HEIGHT_M, function (_a) {
    var theme = _a.theme;
    return theme.colorTextMain;
}, SPACING_S, SPACING_L, SPACING_S, SPACING_S, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled && theme.colorTextLight;
}, function (_a) {
    var isToggleColumn = _a.isToggleColumn, disabled = _a.disabled, theme = _a.theme;
    return !isToggleColumn && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            background-color: ", ";\n        "], ["\n            background-color: ",
        ";\n        "])), disabled
        ? theme.colorBackgroundNeutralLight
        : theme.colorHighlightNotification);
});
var Row = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    border-bottom: ", " solid ", ";\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n\n    overflow: hidden;\n"], ["\n    display: flex;\n    border-bottom: ", " solid ", ";\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n\n    overflow: hidden;\n"])), BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colorBorderGrid;
});
export var totalRowCellId = 'grid-total-row-cell';
var createTotalRow = function (_a) {
    var columns = _a.columns, columnsWidth = _a.columnsWidth, data = _a.data, disabled = _a.disabled, gridDisabled = _a.gridDisabled;
    return (React.createElement(Row, null, columns.reduce(function (result, column, columnIndex) {
        var _a = column.props, field = _a.field, cell = _a.cell;
        var cellData = data[field];
        var width = columnsWidth[column.key];
        var noContent = column.props.isSelectionColumn || column.props.isToggleColumn;
        return result.concat(React.createElement("div", { "data-selector-id": totalRowCellId, key: "Total-Row-Cell-" + columnIndex, style: getFlexStyleForColumn(column, { width: width }) },
            React.createElement(BodyCell, { disabled: disabled || gridDisabled, isToggleColumn: column.props.isToggleColumn }, !noContent && (cell === null || cell === void 0 ? void 0 : cell({
                cellData: cellData,
                rowData: data,
                rowIndex: -1,
                columnWidth: width
            })))));
    }, [])));
};
export default createTotalRow;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=createTotalRow.js.map